import { render, staticRenderFns } from "./SlightlyHappyEmoji.vue?vue&type=template&id=71f5dd7e"
import script from "./SlightlyHappyEmoji.vue?vue&type=script&lang=js"
export * from "./SlightlyHappyEmoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports